<template>
  <div id="main-content-view" class="pt-4 container-fluid">
    <div class="row">
      <div class="col-4 col-sm-3 col-xl-2">
        <SideMenu />
      </div>
      <div class="col-8 col-sm-9 col-xl-10">
        <router-view :key="$route.fullPath"/>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import SideMenu from "@/components/SideMenu.vue"

@Options({
  components: {
    SideMenu
  }
})
export default class MainContent extends Vue {
}
</script>

<style lang="stylus">

</style>
